import { Injectable } from '@angular/core';

import { apiName } from "./data.service";
import { RestService } from "../../../core/services/rest.service";
import { Area } from "./area.model";

@Injectable()
export class AreaApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: Area, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: Area, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"nome","include":"orgao"};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    var filter: any = {"include":"orgao"};
    this._restService.onGetPostId(apiName, objectId, filter, done);
  }

  onGetApiUrl() {
    return apiName;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/areas/shared/area-api.service.ts
 **/